import type { Tile } from '../../hex/types';
import type { SettlementRegionResources } from '../types';

export function extractRegionResources(tiles: Tile[]): SettlementRegionResources {
    const resources: SettlementRegionResources = {
        trees: [],
        fish: 0,
        stone: 0,
        gold: 0,
        wild_life: [],
        canopyCap: 0,
        wildlifeCapBase: 0,
        tileCount: 0,
        plainsTiles: 0,
        fishCap: 0,
        stoneDeposit: 0,
        ironDeposit: 0,
        goldDeposit: 0,
    };
    const addAgeBuckets = (
        target: { age: number; amount: number }[],
        entries: Array<{ age?: number; amount?: number }>,
    ) => {
        entries.forEach((entry) => {
            const age = entry.age ?? 0;
            const amount = entry.amount ?? 0;
            if (!amount) return;
            const existing = target.find((bucket) => bucket.age === age);
            if (existing) existing.amount += amount;
            else target.push({ age, amount });
        });
    };

    tiles.forEach((tile) => {
        resources.tileCount += 1;
        if (tile.biome?.type === 'plains') resources.plainsTiles += 1;
        resources.canopyCap += tile.ecology?.canopyCap ?? 0;
        resources.wildlifeCapBase += tile.ecology?.wildlifeCap ?? 0;
        resources.fishCap += tile.ecology?.fishCap ?? 0;
        resources.stoneDeposit += tile.deposits?.stoneDeposit ?? 0;
        resources.ironDeposit += tile.deposits?.ironDeposit ?? 0;
        resources.goldDeposit += tile.deposits?.goldDeposit ?? 0;
        for (const [key, value] of Object.entries(tile.resources)) {
            switch (key) {
                case 'trees':
                    if (Array.isArray(value)) addAgeBuckets(resources.trees, value);
                    break;
                case 'fish':
                    resources.fish += Array.isArray(value)
                        ? value.reduce((sum, entry) => sum + (entry?.amount || 0), 0)
                        : value?.amount || 0;
                    break;
                case 'stone':
                    resources.stone += Array.isArray(value)
                        ? value.reduce((sum, entry) => sum + (entry?.amount || 0), 0)
                        : value?.amount || 0;
                    break;
                case 'gold':
                    resources.gold += Array.isArray(value)
                        ? value.reduce((sum, entry) => sum + (entry?.amount || 0), 0)
                        : value?.amount || 0;
                    break;
                case 'wild_life':
                    if (Array.isArray(value)) addAgeBuckets(resources.wild_life, value);
                    break;
                default:
                    break;
            }
        }
    });
    return resources;
}
